import { type MetaFunction } from '@remix-run/node'
import progressive from './progressive.png'

export const meta: MetaFunction = () => [
	{ title: 'Progressive' },
	{
		name: 'description',
		content: 'We offer insurance from Progressive.',
	},
]

export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Progressive</h1>

			<img src={progressive} alt="Progressive" className="w-64" />
			<p
				data-paragraph
				className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
			>
				<h3>Products</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Progressive specializes in insurance for the things that move you,
					Automobile, motorcycle, Snowmobile, boat, atv, and other toys.
				</p>
				<h3>Financial Strength</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					A.M. Best has awarded Progressive with the financial strength rating
					of (A+) Superior. With operations in all 50 states, Progressive is one
					of the most widely recognized icons in the national insurance
					industry.
				</p>
				<h3>Contact Information</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Website:{' '}
					<a
						href="https://www.progressive.com"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						https://www.progressive.com (opens in a new tab)
					</a>
				</p>
				<h3>Claims</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					(800) 776-4737
				</p>
				<h3>Make a Payment</h3>
				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					<a
						title="Progressive Payment"
						href="https://www.progressive.com/rp/ezpay"
						target="_blank"
						rel="noopener noreferrer"
						className="text-blue-600 underline"
					>
						https://www.progressive.com/rp/ezpay (opens in a new tab)
					</a>
				</p>
			</p>

			<section>
				<h3>Home Office Address</h3>

				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Progressive
					<br />
					300 North Commons Boulevard
					<br />
					Mayfield Village, OH 44143
				</p>
			</section>
		</main>
	)
}
